export const LOAD_MODEL_YEAR_SUCCESS = 'LOAD_MODEL_YEAR_SUCCESS';
export const VALIDATE_SELECTED_OPTIONS_SUCCESS = 'VALIDATE_SELECTED_OPTIONS_SUCCESS';
export const SET_MODEL_YEARS = 'SET_MODEL_YEARS';
export const SET_MODEL_TRIMS = 'SET_MODEL_TRIMS';
export const SET_DRIVE_POWER_TRAINS = 'SET_DRIVE_POWER_TRAINS';
export const SET_OPTIONS_PACKAGES = 'SET_OPTIONS_PACKAGES';
export const SELECT_INTERIOR_COLOUR = 'SELECT_INTERIOR_COLOUR';
export const CHANGE_BUILD_AND_QUOTE_SECTION = 'CHANGE_BUILD_AND_QUOTE_SECTION';
export const SET_MOBILE_PAYMENT_CALCULATOR_OPENED = 'SET_MOBILE_PAYMENT_CALCULATOR_OPENED';
export const SET_LANG = 'SET_LANG';
